import type { ChatMachineState } from './chat.types';

// Business rule: User can send message only when input has content and connection is established.
export function selectCanSend(state: ChatMachineState): boolean {
  const hasInput = state.inputValue.trim().length > 0;
  const isNotConnecting = state.status !== 'connecting';
  return hasInput && isNotConnecting;
}

export function selectIsLoading(state: ChatMachineState): boolean {
  return state.status === 'connecting';
}
